// extracted by mini-css-extract-plugin
export default {"infoBoxOverride":"_3YkV7wdyz5bd9YyZ2RCYMM"};